import type { UpdatePaymentDTO } from 'gw-edge-client/dist/types/dto/pc/top/edge/capabilities/onlinesales/dto/payment';
import type { BankAccountFieldProps } from '../recoil/types/types';
import { OnlineSales } from 'gw-edge-client';
import { useRecoilValue } from 'recoil';
import { jobAtom } from '../recoil/atoms/jobAtom';
import { updatedPaymentInformationAtom } from '../recoil/atoms/updatedPaymentInformationAtom';
import { fetchedPaymentInformationAtom } from '../recoil/atoms/fetchedPaymentInformationAtom';
import { paymentFrequencyMap } from '../utils/currencyUtil';
import { jobInfoAtom } from '../recoil/atoms/jobInfoAtom';

export function usePaymentInformationHook(): {
    updatePaymentInformation: (bankAccountInfo: BankAccountFieldProps) => Promise<void>;
} {
    const { selectedPaymentFrequency } = useRecoilValue(jobAtom);
    const { jobNumber, sessionId } = useRecoilValue(jobInfoAtom);
    const { cpr, cvr } = useRecoilValue(updatedPaymentInformationAtom);
    const { paymentMethod, bankReference, accountNumber } = useRecoilValue(
        fetchedPaymentInformationAtom
    );
    const updatePaymentInformationDto: UpdatePaymentDTO = {
        jobId: jobNumber,
        paymentMethod: paymentMethod ?? '',
        bankAccount: {
            registrationNumber: bankReference ?? '',
            accountNumber: accountNumber ?? ''
        },
        selectedPaymentFrequency: selectedPaymentFrequency ?? paymentFrequencyMap.monthly,
        cpr,
        cvr
    };

    const updatePaymentInformation = async (
        bankAccountInfo: BankAccountFieldProps
    ): Promise<void> => {
        const paymentInfo = {
            ...updatePaymentInformationDto,
            bankAccount: {
                registrationNumber: bankAccountInfo.bankReference ?? bankReference,
                accountNumber: bankAccountInfo.accountNumber ?? accountNumber
            }
        };
        await OnlineSales.updatePaymentInformation(paymentInfo, sessionId);
    };

    return { updatePaymentInformation };
}
